import React, { Component } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { Row, Col, Container } from 'react-bootstrap';

export class MedCommercial extends Component {
    render() {
        // Listas de proveedores divididas por columnas para mayor orden
        const col1 = [
            "3M PHARMA", "ABBOTT", "ABSORBENTES", "ADAMED", "ADECAST", "ALFER", "AMBIDERM", 
            "AMERICA", "AMICELCO, S. A.", "AMILAB", "ANCALMO", "ARSAL", "ASOFARMA", 
            "ASTA MEDICA", "BABY CHIC", "BAGO", "BAYER", "BAYER_FARMA", "BDF", "BENESTAR", 
            "BIC", "BIOMEDICAL", "BIOQUIMICAS", "BMA Pharma", "BODEGA DE CONSUMO", "BOGA", 
            "BOHERINGER", "BONIN", "BRISTOL-MYERS SQUIBB", "BUSSIE", "CADBURY ADAMS", 
            "CALIQUIMICA", "CAPLIN POINT", "CENTRO DISTRIBUIDOR, S. A", "CHEMILCO INTERNACIONAL", 
            "CHINOIN", "CINFA", "CITOCOLOR", "CODISA", "COFARM", "COLGATE PALMOLIVE", 
            "COTEFASA", "CUREBAND", "DAVIS", "DIPROFARM, S. A.", "DIQUIVA, S. A.", 
            "DISFAVIL", "DISOVA", "DISTAMPAR", "DONOVAN WERKE", "EDIGAR", "ELU", 
            "EMILIO HERRERA", "EVENFLO", "EVEREADY", "FARMA QUIMICA", "FARMACAPS", 
            "FARMAMEDICA", "FRESKESITO", "FRYCIA", "FUTURA", "GAMMA", "GARNIER", 
            "GB PHARMA", "GENERICS (2238 – 2335)", "GENOMALAB", "GERBER", "GLAXO PHARMA"
        ];

        const col2 = [
            "GLAXO SMITHKLINE", "GRISI", "GRUNENTHAL", "GRUPO FARMA", "HAEUSSLER", 
            "HCK JIMCORP", "HELOS", "HERBRUGER", "HUGGIES", "ICA", "ICN", "IKSAM", 
            "INFASA", "INPROFAR", "INTECFA", "INTERFARM", "ISIS PHARMA", "ITALBIOTIC", 
            "JANSSEN", "JHONSON CONSUMO", "JOHNSON BABY", "KANDY", "KENLY ROCHAS", 
            "KIMBERLY KLARK", "KRAL", "LA SANTE", "LABORATORIOS UNIDOS", "LAFRANCOL", 
            "LAINEZ", "LANCASCO", "LAPRIN", "LAPRIN OTC", "LASANA", "LEROY-ELAS TOMEDICA", 
            "LEVEN", "LOPEZ", "LORALVA", "LOREAL", "LOS DOS", "MCKESSON", "MEAL LITE", 
            "MEDIC", "MEDINOVA", "MEDIPRODUCTS", "MEDLEY", "MEGAPHARM", "MELGAR", 
            "MENARINI", "MENDEZ-RUIZ", "MENTHOLATUM", "MEPHA", "MERCAFARMA", "MERCK", 
            "METTLER", "MILAGRO DE LA SELVA", "MONERAUX", "NIELSEN PHARMA (2269-7729)", 
            "NITRO", "NLSA", "NOVARTIS", "NOVUM", "NUN`Z", "NYAL", "OM PHARMA", "ORAN", 
            "ORION", "PADES", "PAILL"
        ];

        const col3 = [
            "PASMO", "PFIZER", "PHARMAKIN", "PHARMALAT", "PHARMATON", "PHENIEL J. M.", 
            "PHISA", "PIERSAN", "PLASTYMET", "PROCTER & GAMBLE", "PRODIAGNOSTIC", 
            "PRODIN", "PRODUCTOS NUEVOS", "SELECTPUARMA", "PROFONSA", "PROTEIN", 
            "QUALIPHARM", "QUIFARMA", "QUIMIFAR", "REDI", "ROBERPHARM", "ROCHE", 
            "ROLAND LOUIS", "ROSSATTA", "ROTTA", "ROWA", "ROWE", "SAN LUIS", "SANDOZ", 
            "SANOFI-AVENTIS", "SANTA ANA", "SANTA FE", "SANTE", "SC JOHNSON", "SCA", 
            "SCHERING", "SCHERING GUATEMALTECA", "SCHERING PLOUGH", "SEARLE", 
            "SELECTFARMA", "SENOSIAN", "SENSAT", "SERVIER", "SIERRA", "STEIN", 
            "SUDORIN", "SUIZOS", "SUPERIOR", "TG MEDICALS", "THERFAM", "TRINIDAD", 
            "TRINOMED", "UNILEVER", "UNIPHARM", "USETHICALS", "VARIOS", "VESA", 
            "VIDA", "VIJOSA", "VIZCAINO", "WALKIRIA", "WASHINGTON", "WINZZER", 
            "WOOSAM MEDICAL", "WYETH", "WYSE CHOICE", "Z.MEDICAL", "ZUUM"
        ];

        return (
            <div>
                <Header />
                <Container className="fondo-texto py-4">
                    <Row className="mb-4 text-center">
                        <Col>
                            <h1 className='text-center'>Brand Name Medications</h1>
                        </Col>
                    </Row>

                    <div className="mb-4">
                        <p className="lead">
                            <strong>Wholesale.</strong> Some of the houses we work with: 
                            Capsules – Tablets, Syrup Jar, Suspension, Vial – Blister
                        </p>
                    </div>

                    <Row>
                        {[col1, col2, col3].map((column, index) => (
                            <Col key={index} sm={12} md={4}>
                                <ul className="list-unstyled">
                                    {column.map((item, i) => (
                                        <li key={i} className="small mb-1">• {item}</li>
                                    ))}
                                </ul>
                            </Col>
                        ))}
                    </Row>
                </Container>
                <Footer />
            </div>
        );
    }
}